import numeral from 'numeral';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';
import { HiOutlineSearch } from 'react-icons/hi';
import { ImLocation } from 'react-icons/im';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { commercialLangObj, residentialLangObj } from '../../config/DummyData';
import {
  bathRoomsFilterOptions,
  roomFilterOptions,
  termsFilterOptions
} from '../../constant/commonData';
import { getWindowWidth } from '../../CustomHooks/isMobileViewHook';
import HomeMoreFiltersModal from '../../modals/HomeMoreFiltersModal';
import Button from '../Button/Button';
import CustomOverlay from '../CustomOverlay';
import Input from '../Input/Input';
import LocationFiltersOverlay from '../LocationFilterOverlay';
import MapMain from '../maps/MapMain';
import classes from './BuyRentCommercialFilters.module.css';
const FilterDiv = ({ text, icon, iconRight, className = '', textClassName = '', ...props }) => {
  return (
    <div className={[classes.dropdownBox, className].join(' ')} {...props}>
      <div>
        {icon} <span className={[textClassName].join(' ')}>{text}</span>
      </div>
      {iconRight || <MdOutlineKeyboardArrowDown size={20} className={classes.icons} />}
    </div>
  );
};

function BuyRentCommercialFilters({
  onSearch,
  containerClass = '',
  // data,
  filtersWrapperClass = '',
  rowClass = '',
  filters,
  setFilters,
  setSearchText,
  searchText,
  savedSearch,
  disabledSearch,
  t
}) {
  const locationRef = useRef(null);
  const { propertyTypes } = useSelector((state) => state.commonReducer);
  const { currency, areaUnit } = useSelector((state) => state.converterReducer);

  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const selectedPropertyType = useLocation()?.pathname?.split('/')[1];
  const [filterType, setFilterType] = useState('buy');
  const [moreFiltersModal, setMoreFiltersModal] = useState(false);
  const [screenWidth, setScreenWidth] = useState();
  const [thePropertyType, setThePropertyType] = useState(
    filters?.propertyClassification?.['en']?.toLowerCase() || ''
  ); // ["residential", "commercial"]

  // For Popover
  const [show, setShow] = useState('');
  const [target, setTarget] = useState(null);

  useEffect(() => {
    setThePropertyType(filters?.propertyClassification?.['en']?.toLowerCase() || '');
    // If filters.entity is array of string IDs, map to propertyType objects
    if (
      Array.isArray(filters?.entity) &&
      filters.entity.length > 0 &&
      typeof filters.entity[0] === 'string'
    ) {
      const mapped = filters.entity
        .map((id) => propertyTypes?.find((pt) => pt._id === id))
        .filter(Boolean);
      if (mapped.length > 0) {
        setFilters((prev) => ({ ...prev, entity: mapped }));
      }
    }
  }, [filters, propertyTypes]);

  useEffect(() => {
    if (selectedPropertyType) {
      setFilterType(selectedPropertyType);
    }
  }, [selectedPropertyType]);

  const handleClick = (event, type) => {
    if (type) {
      setShow(type);
    } else {
      setShow('');
    }
    if (event) {
      setTarget(event.target);
    } else {
      setTarget(null);
    }
  };

  // Apply Filters
  function applyFilters(type, data, keepOpen = false) {
    if (type == 'location') {
      handleClick();
    }

    // Handle multiselect for bathrooms and rooms
    if (['bathrooms', 'rooms'].includes(type)) {
      setFilters((prev) => {
        const fieldName = Object.keys(data)[0];
        const newValue = data[fieldName];
        const currentValue = prev[fieldName];

        // Initialize as array if not already
        let updatedArray =
          Array.isArray(currentValue) && currentValue.length > 0 ? [...currentValue] : [];

        // Special handling for rooms and bathrooms with "Any" logic
        const isAnyValue =
          newValue?.[selectedLanguage] === 'Any' ||
          newValue === 'Any' ||
          (typeof newValue === 'object' && newValue?.en === 'Any');
        const hasAnyInArray = updatedArray.some(
          (item) =>
            item?.[selectedLanguage] === 'Any' ||
            item === 'Any' ||
            (typeof item === 'object' && item?.en === 'Any')
        );

        if (isAnyValue) {
          // If selecting "Any", clear all other selections and set only "Any"
          updatedArray = [newValue];
        } else {
          // If selecting a specific value, remove "Any" if it exists
          if (hasAnyInArray) {
            updatedArray = updatedArray.filter(
              (item) =>
                !(
                  item?.[selectedLanguage] === 'Any' ||
                  item === 'Any' ||
                  (typeof item === 'object' && item?.en === 'Any')
                )
            );
          }

          // Check if value already exists
          const existingIndex = updatedArray.findIndex((item) =>
            typeof item === 'object' && typeof newValue === 'object'
              ? JSON.stringify(item) === JSON.stringify(newValue)
              : item === newValue
          );

          if (existingIndex >= 0) {
            // Remove if exists
            updatedArray.splice(existingIndex, 1);
          } else {
            // Add if doesn't exist
            updatedArray.push(newValue);
          }
        }

        return {
          ...prev,
          [fieldName]: updatedArray
        };
      });
    } else {
      setFilters((prev) => ({ ...prev, ...data }));
    }

    if (!keepOpen) {
      setShow('');
    }
  }

  useEffect(() => {
    getWindowWidth(setScreenWidth);
  }, []);

  useEffect(() => {
    if (savedSearch) {
      locationRef?.current?.updateLocation(savedSearch);
    }
  }, [savedSearch]);

  const handleSearch = (filterParams = {}) => {
    onSearch?.(filterParams);
  };

  // ``````````````````````````````````````````` FILTERS START `````````````````````````````````

  // Location Filter
  const LocationFilter = () => (
    <CustomOverlay
      show={show == 'location'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          onClick={(e) => handleClick(e, 'location')}
          icon={
            screenWidth <= 768 ? (
              false
            ) : (
              <ImLocation color={'var(--secondary-clr)'} className={classes.icon} />
            )
          }
          text={
            screenWidth <= 768 ? (
              <ImLocation color={'var(--secondary-clr)'} />
            ) : (
              filters?.province?.name[selectedLanguage] || t('filters.location')
            )
          }
        />
      }>
      <div className={classes.overlayBox}>
        <LocationFiltersOverlay
          setLocationState={setFilters}
          locationState={filters}
          t={t}
          ref={locationRef}
          setClose={() => handleClick('')}
        />
      </div>
    </CustomOverlay>
  );

  // commercial and residential filter

  const CommercialResidentialFilter = () => (
    <CustomOverlay
      show={show == 'residential-commercial'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          onClick={(e) => {
            handleClick(e, 'residential-commercial');
          }}
          className={[classes.propertyType, screenWidth <= 992 && classes.fullWidth].join(' ')}
          text={
            Array.isArray(filters?.entity) && filters?.entity.length > 0
              ? filters.entity.map((item) => ` ${item?.type}`).join(', ')
              : t('filters.propertyType')
          }
          textClassName={'maxLine1'}
        />
      }>
      <div className={[classes.overlayBox, classes.p0].join(' ')}>
        <ul className={classes.propertyTypeTabs}>
          <li>
            <span
              data-selected={thePropertyType == 'residential'}
              onClick={() => {
                setThePropertyType('residential');
                setFilters((prev) => ({
                  ...prev,
                  propertyClassification: residentialLangObj
                }));
              }}>
              {t('filters.residential')}
            </span>
          </li>
          <li>
            <span
              data-selected={thePropertyType == 'commercial'}
              onClick={() => {
                setThePropertyType('commercial');
                setFilters((prev) => ({
                  ...prev,
                  propertyClassification: commercialLangObj
                }));
              }}>
              {t('filters.commercial')}
            </span>
          </li>
        </ul>
        <ul className={classes.listOptionsWithBrBtm}>
          {propertyTypes
            ?.filter((e) => e?.type === thePropertyType)
            ?.map((item, key) => {
              const isSelected = Array.isArray(filters?.entity)
                ? filters.entity.some((selected) => selected._id === item._id)
                : false;
              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setFilters((prev) => {
                      let updated = Array.isArray(prev.entity) ? [...prev.entity] : [];
                      // If selecting a type different from previous, clear all and select only new
                      if (updated.length > 0 && updated[0]?.type !== item.type) {
                        updated = [item];
                      } else {
                        const idx = updated.findIndex((selected) => selected._id === item._id);
                        if (idx > -1) {
                          updated.splice(idx, 1);
                        } else {
                          updated.push(item);
                        }
                      }
                      // Only update if changed
                      if (
                        updated.length !== prev.entity?.length ||
                        updated.some((u, i) => u._id !== prev.entity?.[i]?._id)
                      ) {
                        return {
                          ...prev,
                          entity: updated
                        };
                      }
                      return prev;
                    });
                  }}>
                  {item?.title?.[selectedLanguage]}
                  {isSelected && (
                    <img
                      src="/tick.png"
                      alt="checkmark"
                      style={{ width: '12px', height: '12px', marginLeft: '8px' }}
                    />
                  )}
                </li>
              );
            })}
        </ul>
      </div>
    </CustomOverlay>
  );

  // price filter
  // const PriceFilter = () => (
  //   <CustomOverlay
  //     show={show == 'price'}
  //     target={target}
  //     handleClose={(e) => handleClick('', e)}
  //     targetElement={
  //       <FilterDiv
  //         onClick={(e) => {
  //           handleClick(e, 'price');
  //         }}
  //         className={screenWidth <= 1200 && classes.fullWidth}
  //         text={
  //           filters?.minPrice || filters?.maxPrice
  //             ? `${numeral(filters?.minPrice).format(0, 0) || 0} - ${
  //                 numeral(filters?.maxPrice).format(0, 0) || '∞'
  //               }`
  //             : t('filters.price')
  //         }
  //         textClassName={'maxLine1'}
  //       />
  //     }>
  //     <div className={[classes.overlayBox, classes.minWidth350].join(' ')}>
  //       <label className={classes?.priceRange}>Price Range ({currency?.symbol})</label>

  //       <Row>
  //         <Col md={6}>
  //           <Input
  //             value={filters?.minPrice}
  //             // label={t('filters.minPrice')}
  //             placeholder={t('filters.minPricePlaceholder')}
  //             type={'number'}
  //             min={0}
  //             setValue={(e) => {
  //               setFilters((prev) => ({ ...prev, minPrice: e }));
  //             }}
  //           />
  //         </Col>
  //         <Col md={6}>
  //           <Input
  //             // label={t('filters.maxPrice')}
  //             placeholder={t('filters.maxPricePlaceholder')}
  //             value={filters?.maxPrice}
  //             type={'number'}
  //             setValue={(e) => {
  //               setFilters((prev) => ({ ...prev, maxPrice: e }));
  //             }}
  //             min={0}
  //           />
  //         </Col>
  //         <Col md={12}>
  //           <div className={[classes.spBtw, classes.mt20].join(' ')}>
  //             <Button
  //               className={classes.clearBtn}
  //               borderRadius={'9px'}
  //               onClick={() => {
  //                 setFilters((prev) => ({ ...prev, minPrice: '', maxPrice: '' }));
  //               }}>
  //               {t('filters.clearBtn')}
  //             </Button>
  //             <Button
  //               borderRadius={'9px'}
  //               className={classes.btnMaxContent}
  //               onClick={() => {
  //                 handleClick();
  //               }}>
  //               {t('filters.applyBtn')}
  //             </Button>
  //           </div>
  //         </Col>
  //       </Row>
  //     </div>
  //   </CustomOverlay>
  // );

  // ``````````````````````````````````````````` FILTERS END `````````````````````````````````

  return (
    <Container className={`${containerClass}`}>
      <div className={[classes.otherOptions, filtersWrapperClass].join(' ')}>
        <Row className={[classes.row, 'gx-0', rowClass].join(' ')}>
          <Col md={2} className={classes.width170}>
            <LocationFilter />
          </Col>
          {/* location overlay */}
          <Col md={4}>
            <MapMain
              showLandMarks={false}
              setCoordinates={(e) => {
                setFilters((prev) => ({ ...prev, lng: e?.lng, lat: e?.lat }));
              }}
              address={searchText}
              setAddress={(e) => {
                setSearchText(e);
                setFilters((prev) => ({
                  ...prev,
                  nearby: false,
                  province: null,
                  town: null,
                  neighborhood: null
                }));
              }}
              placeholder={t('filters.search')}
              type="places"
              comboRootClassName={classes?.searchInput}
              deleteIcon
            />
          </Col>
          {/* Residential Commercial Start */}
          {screenWidth > 992 && (
            <Col md={2} className={classes.width170}>
              <CommercialResidentialFilter />
            </Col>
          )}

          {screenWidth > 1200 && (
            // <Col md={2} className={classes.width170}>
            //   <PriceFilter />
            // </Col>
            <Col md={12} className={classes.width170}>
              <PriceFilter
                show={show}
                target={target}
                handleClick={handleClick}
                screenWidth={screenWidth}
                classes={classes}
                filters={filters}
                setFilters={setFilters}
                t={t}
                currency={currency}
                numeral={numeral}
              />
            </Col>
          )}

          {/* 2nd Option */}
          {screenWidth > 992 && (
            <Col md={12} className={classes.width170}>
              <div className={classes.secondLineOptions}>
                {/* price filter */}

                {/* area filter */}
                <CustomOverlay
                  show={show == 'area'}
                  target={target}
                  handleClose={(e) => handleClick('', e)}
                  targetElement={
                    <FilterDiv
                      onClick={(e) => {
                        handleClick(e, 'area');
                      }}
                      text={
                        filters?.minArea || filters?.maxArea
                          ? `${numeral(Number(filters?.minArea) || 0).format(0, 0)} - ${
                              numeral(Number(filters?.maxArea)).format(0, 0) || '∞'
                            }`
                          : t('filters.area')
                      }
                      textClassName={'maxLine1'}
                    />
                  }>
                  <div className={[classes.overlayBox, classes.minWidth350].join(' ')}>
                    <label className={classes?.priceRange}>Area Range ({areaUnit})</label>

                    <Row>
                      <Col md={6}>
                        <Input
                          value={filters?.minArea}
                          // label={t('filters.minArea')}
                          placeholder={t('filters.minAreaPlaceholder')}
                          type={'number'}
                          setValue={(e) => {
                            setFilters((prev) => ({ ...prev, minArea: e }));
                          }}
                          min={0}
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          // label={t('filters.maxArea')}
                          placeholder={t('filters.maxAreaPlaceholder')}
                          value={filters?.maxArea}
                          type={'number'}
                          setValue={(e) => {
                            setFilters((prev) => ({ ...prev, maxArea: e }));
                          }}
                          min={0}
                        />
                      </Col>
                      <Col md={12}>
                        <div className={[classes.spBtw, classes.mt20].join(' ')}>
                          <Button
                            className={classes.clearBtn}
                            borderRadius={'9px'}
                            onClick={() => {
                              setFilters((prev) => ({
                                ...prev,
                                minArea: '',
                                maxArea: ''
                              }));
                            }}>
                            {t('filters.clearBtn')}
                          </Button>
                          <Button
                            borderRadius={'9px'}
                            className={classes.btnMaxContent}
                            onClick={() => {
                              handleClick();
                            }}>
                            {t('filters.applyBtn')}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CustomOverlay>
                {filters?.propertyClassification?.en?.toLowerCase() == 'residential' && (
                  <CustomOverlay
                    show={show == 'rooms'}
                    target={target}
                    handleClose={(e) => handleClick('', e)}
                    keepOpen={true}
                    targetElement={
                      <FilterDiv
                        onClick={(e) => {
                          handleClick(e, 'rooms');
                        }}
                        text={
                          Array.isArray(filters?.noOfRooms) && filters?.noOfRooms?.length > 0
                            ? `${filters.noOfRooms.length} selected`
                            : // : filters?.noOfRooms
                              // ? filters?.noOfRooms?.[selectedLanguage]
                              t('filters.rooms')
                        }
                        textClassName={'maxLine1'}
                      />
                    }>
                    <div className={[classes.overlayBox, classes.p0].join(' ')}>
                      <ul className={classes.listOptionsWithBrBtm}>
                        {roomFilterOptions?.map((item, key) => (
                          <li
                            key={`${key}-${item}`}
                            data-selected={
                              Array.isArray(filters?.noOfRooms)
                                ? filters.noOfRooms.some((room) =>
                                    typeof room === 'string'
                                      ? room === item?.[selectedLanguage]
                                      : room?.[selectedLanguage] === item?.[selectedLanguage]
                                  )
                                : filters?.noOfRooms?.[selectedLanguage] == item?.[selectedLanguage]
                            }
                            onClick={() => {
                              applyFilters(
                                'rooms',
                                {
                                  noOfRooms: item
                                },
                                true
                              );
                            }}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                            {item?.[selectedLanguage]}
                            {((Array.isArray(filters?.noOfRooms) &&
                              filters.noOfRooms.some((room) =>
                                typeof room === 'string'
                                  ? room === item?.[selectedLanguage]
                                  : room?.[selectedLanguage] === item?.[selectedLanguage]
                              )) ||
                              (!Array.isArray(filters?.noOfRooms) &&
                                filters?.noOfRooms?.[selectedLanguage] ==
                                  item?.[selectedLanguage])) && (
                              <img
                                src="/tick.png"
                                alt="checkmark"
                                style={{
                                  width: '12px',
                                  height: '12px',
                                  marginLeft: '8px'
                                }}
                              />
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </CustomOverlay>
                )}
              </div>
            </Col>
          )}

          {/* Residential Commercial */}
          <Col md={2} className={classes.width150}>
            <FilterDiv
              onClick={() => {
                setMoreFiltersModal(true);
              }}
              iconRight={screenWidth <= 768 ? false : <FaFilter className={classes.icon} />}
              text={screenWidth <= 768 ? <FaFilter className={classes.icon} /> : t('filters.title')}
            />
          </Col>

          <Col md={2} className={classes.searchBtnWidth}>
            <Button
              leftIcon={screenWidth < 768 && <HiOutlineSearch size={24} />}
              label={screenWidth >= 768 ? 'Search' : ''}
              className={classes.searchBtn}
              onClick={() => handleSearch()}
              variant="primary"
              disabled={disabledSearch}
              borderRadius="8px"
            />
          </Col>
        </Row>
      </div>
      {/* more filters modal */}
      {moreFiltersModal && (
        <HomeMoreFiltersModal
          show={moreFiltersModal}
          setShow={setMoreFiltersModal}
          setFilters={setFilters}
          filters={filters}
          onSearch={handleSearch}>
          {/* Residential Commercial Start */}
          {screenWidth <= 992 && (
            <Col md={12}>
              <CommercialResidentialFilter />
            </Col>
          )}

          {/* BathRooms */}
          {filters?.propertyClassification?.en?.toLowerCase() == 'residential' && (
            <CustomOverlay
              show={show == 'bathrooms'}
              target={target}
              handleClose={(e) => handleClick('', e)}
              targetElement={
                <FilterDiv
                  onClick={(e) => {
                    handleClick(e, 'bathrooms');
                  }}
                  className={classes.fullWidth}
                  text={
                    Array.isArray(filters?.noOfBathrooms) && filters?.noOfBathrooms?.length > 0
                      ? `${filters.noOfBathrooms.length} selected`
                      : t('filters.bathrooms')
                  }
                />
              }>
              <div className={[classes.overlayBox, classes.p0].join(' ')}>
                <ul className={classes.listOptionsWithBrBtm}>
                  {bathRoomsFilterOptions?.map((item, key) => {
                    const isSelected = Array.isArray(filters?.noOfBathrooms)
                      ? filters?.noOfBathrooms?.some((bath) =>
                          typeof bath === 'object' && typeof item === 'object'
                            ? JSON.stringify(bath) === JSON.stringify(item)
                            : bath === item
                        )
                      : filters?.noOfBathrooms == item;

                    return (
                      <li key={`${key}-${item?.[selectedLanguage]}`} data-selected={isSelected}>
                        <button
                          type="button"
                          data-selected={isSelected}
                          onClick={() => applyFilters('bathrooms', { noOfBathrooms: item }, true)}
                          className={`${classes.termOptionButton} btnWrapper`}>
                          {item?.[selectedLanguage]}

                          {isSelected && (
                            <img
                              src="/tick.png"
                              alt="checkmark"
                              style={{
                                width: '12px',
                                height: '12px',
                                marginLeft: '8px'
                              }}
                            />
                          )}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </CustomOverlay>
          )}

          {/* Residential Commercial */}
          {/* Price */}
          {screenWidth <= 1200 && (
            <Col md={12}>
              <PriceFilter
                show={show}
                target={target}
                handleClick={handleClick}
                screenWidth={screenWidth}
                classes={classes}
                filters={filters}
                setFilters={setFilters}
                t={t}
                currency={currency}
                numeral={numeral}
              />
            </Col>
          )}

          {/* Area */}
          {screenWidth <= 992 && (
            <Col md={12}>
              <CustomOverlay
                show={show == 'area'}
                target={target}
                handleClose={(e) => handleClick('', e)}
                targetElement={
                  <FilterDiv
                    onClick={(e) => {
                      handleClick(e, 'area');
                    }}
                    className={classes.fullWidth}
                    text={
                      filters?.minArea || filters?.maxArea
                        ? `${numeral(Number(filters?.minArea) || 0).format(0, 0)} - ${
                            numeral(Number(filters?.maxArea)).format(0, 0) || '∞'
                          }`
                        : t('filters.area')
                    }
                  />
                }>
                <div className={[classes.overlayBox, classes.minWidth350].join(' ')}>
                  <label className={classes?.priceRange}>Area Range ({areaUnit})</label>

                  <Row>
                    <Col md={6}>
                      <Input
                        value={filters?.minArea}
                        // label={t('filters.minArea')}
                        placeholder={t('filters.minAreaPlaceholder')}
                        type={'number'}
                        setValue={(e) => {
                          setFilters((prev) => ({ ...prev, minArea: e }));
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <Input
                        // label={t('filters.maxArea')}
                        placeholder={t('filters.maxAreaPlaceholder')}
                        value={filters?.maxArea}
                        type={'number'}
                        setValue={(e) => {
                          setFilters((prev) => ({ ...prev, maxArea: e }));
                        }}
                      />
                    </Col>
                    <Col md={12}>
                      <div className={[classes.spBtw, classes.mt20].join(' ')}>
                        <Button
                          borderRadius={'9px'}
                          className={classes.clearBtn}
                          onClick={() => {
                            setFilters((prev) => ({ ...prev, minArea: '', maxArea: '' }));
                          }}>
                          {t('filters.clearBtn')}
                        </Button>
                        <Button
                          borderRadius={'9px'}
                          className={classes.btnMaxContent}
                          onClick={() => {
                            handleClick();
                          }}>
                          {t('filters.applyBtn')}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CustomOverlay>
            </Col>
          )}

          {/* rooms filter */}
          {screenWidth <= 1200 &&
            filters?.propertyClassification?.en?.toLowerCase() == 'residential' && (
              <Col md={12}>
                <CustomOverlay
                  show={show == 'rooms'}
                  target={target}
                  handleClose={(e) => handleClick('', e)}
                  keepOpen={true}
                  targetElement={
                    <FilterDiv
                      onClick={(e) => {
                        handleClick(e, 'rooms');
                      }}
                      className={classes.fullWidth}
                      text={
                        Array.isArray(filters?.noOfRooms) && filters?.noOfRooms?.length > 0
                          ? `${filters.noOfRooms.length} selected`
                          : t('filters.rooms')
                      }
                      textClassName={'maxLine1'}
                    />
                  }>
                  <div className={[classes.overlayBox, classes.p0].join(' ')}>
                    <ul className={classes.listOptionsWithBrBtm}>
                      {roomFilterOptions?.map((item, key) => (
                        <li
                          key={key}
                          data-selected={
                            Array.isArray(filters?.noOfRooms)
                              ? filters.noOfRooms.some((room) =>
                                  typeof room === 'string'
                                    ? room === item?.[selectedLanguage]
                                    : room?.[selectedLanguage] === item?.[selectedLanguage]
                                )
                              : filters?.noOfRooms?.[selectedLanguage] == item?.[selectedLanguage]
                          }
                          onClick={() => {
                            applyFilters(
                              'rooms',
                              {
                                noOfRooms: item
                              },
                              true
                            );
                          }}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}>
                          {item?.[selectedLanguage]}
                          {((Array.isArray(filters?.noOfRooms) &&
                            filters.noOfRooms.some((room) =>
                              typeof room === 'string'
                                ? room === item?.[selectedLanguage]
                                : room?.[selectedLanguage] === item?.[selectedLanguage]
                            )) ||
                            (!Array.isArray(filters?.noOfRooms) &&
                              filters?.noOfRooms?.[selectedLanguage] ==
                                item?.[selectedLanguage])) && (
                            <img
                              src="/tick.png"
                              alt="checkmark"
                              style={{
                                width: '12px',
                                height: '12px',
                                marginLeft: '8px'
                              }}
                            />
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </CustomOverlay>
              </Col>
            )}
          {/* terms filter */}
          {screenWidth <= 1200 && filterType == 'rent' && (
            <Col md={12}>
              <CustomOverlay
                show={show == 'terms'}
                target={target}
                handleClose={(e) => handleClick('', e)}
                targetElement={
                  <FilterDiv
                    onClick={(e) => {
                      handleClick(e, 'terms');
                    }}
                    className={classes.fullWidth}
                    text={t('filters.terms')}
                  />
                }>
                <div className={[classes.overlayBox, classes.p0].join(' ')}>
                  <ul className={classes.listOptionsWithBrBtm}>
                    {termsFilterOptions?.map((item) => (
                      <li key={item} data-selected={filters?.terms == item}>
                        <button
                          type="button"
                          onClick={() => applyFilters('terms', { terms: item })}
                          data-selected={filters?.terms == item}
                          className={`${classes.termOptionButton} btnWrapper`}>
                          {item}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </CustomOverlay>
            </Col>
          )}
        </HomeMoreFiltersModal>
      )}
    </Container>
  );
}

export default BuyRentCommercialFilters;
const PriceFilter = ({
  show,
  target,
  handleClick,
  screenWidth,
  classes,
  filters,
  setFilters,
  t,
  currency,
  numeral
}) => (
  <CustomOverlay
    show={show == 'price'}
    target={target}
    handleClose={(e) => handleClick('', e)}
    targetElement={
      <FilterDiv
        onClick={(e) => {
          handleClick(e, 'price');
        }}
        className={screenWidth <= 1200 && classes.fullWidth}
        text={
          filters?.minPrice || filters?.maxPrice
            ? `${numeral(filters?.minPrice).format(0, 0) || 0} - ${
                numeral(filters?.maxPrice).format(0, 0) || '∞'
              }`
            : t('filters.price')
        }
        textClassName={'maxLine1'}
      />
    }>
    <div className={[classes.overlayBox, classes.minWidth350].join(' ')}>
      <label className={classes?.priceRange}>Price Range ({currency?.symbol})</label>

      <Row>
        <Col md={6}>
          <Input
            value={filters?.minPrice}
            // label={t('filters.minPrice')}
            placeholder={t('filters.minPricePlaceholder')}
            type={'number'}
            min={0}
            setValue={(e) => {
              setFilters((prev) => ({ ...prev, minPrice: e }));
            }}
          />
        </Col>
        <Col md={6}>
          <Input
            // label={t('filters.maxPrice')}
            placeholder={t('filters.maxPricePlaceholder')}
            value={filters?.maxPrice}
            type={'number'}
            setValue={(e) => {
              setFilters((prev) => ({ ...prev, maxPrice: e }));
            }}
            min={0}
          />
        </Col>
        <Col md={12}>
          <div className={[classes.spBtw, classes.mt20].join(' ')}>
            <Button
              className={classes.clearBtn}
              borderRadius={'9px'}
              onClick={() => {
                setFilters((prev) => ({ ...prev, minPrice: '', maxPrice: '' }));
              }}>
              {t('filters.clearBtn')}
            </Button>
            <Button
              borderRadius={'9px'}
              className={classes.btnMaxContent}
              onClick={() => {
                handleClick();
              }}>
              {t('filters.applyBtn')}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  </CustomOverlay>
);
